import { CommonHeaderPublishButton } from "@/components/features/marketing/_shared/components/header/publish-button/publish-button";

import { usePublishButton } from "./hooks/use-publish-button";

export const HeaderPublishButton = () => {
	const { isValid, onPublish, inSale } = usePublishButton();

	return <CommonHeaderPublishButton inSale={inSale} isValid={isValid} onPublish={onPublish} />;
};

HeaderPublishButton.displayName = "HeaderPublishButton";
